function refreshCart(){
	$.ajax({
		url : '/cart.js',
		type : 'GET',
		dataType: 'json',
		success: function(cart){
			$(".global-cart-count").fadeOut(400,function(){
				$(this).html(cart.item_count).fadeIn(400);
			});

		}
	});
	$.get('/cart?view=json', function (cart, textStatus) {
		$(".cart-notif-con").html(cart);
		$(".cart-notif-loading").hide();
		if($(".cart-notif-con").hasClass("added"))
		{
			setTimeout(function(){
				$(".cart-notif-con").removeClass("added")
			},2000);
		}
	});
}

function refreshCartWithoutFading(){
	$.ajax({
		url : '/cart.js',
		type : 'GET',
		dataType: 'json',
		success: function(cart){
			$(".global-cart-count").fadeOut(400,function(){
				$(this).html(cart.item_count).fadeIn(400);
			});
		}
	});
	$.get('/cart?view=json', function (cart, textStatus) {
		$(".cart-notif-con").html(cart);
		$(".cart-notif-loading").hide();
		if($(".cart-notif-con").hasClass("added"))
		{
// 			setTimeout(function(){
// 				$(".cart-notif-con").removeClass("added")
// 			},2000);
		}
	});
}

$(function(){
	$(".search-form").on("submit",function(){
		var dex = $(this).find(".input").val();
		var lex = "";
		if (dex.trim() !== "") {      
			var lex = "*";
		}
		$(this).find('#q').val('title:'+dex+lex);
		return true;
	});

	$(".global-select-div-selection").on("change",function(){
		t = $(this);
		t.prev().html(t.find("option:selected").text());
	});
});